import { jsonldAddressStreet } from './JsonldStore';

export const updateJsonldAddressStreet = (value) => jsonldAddressStreet.update((oldValue) => value);
